module.exports = "<main>\r\n  <router-outlet></router-outlet>\r\n</main>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/playitadmin_frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main